import { useEffect, useState } from 'react';
import {
    Container,
    Content,
    IconContact,
    Description
} from './styled';
import {
    FaUser,
    FaUsers
} from "react-icons/fa6";
import { Modal } from '../../../../components';
import { Footer } from '../../components';
import { List } from './List';
import { IoMdContact } from "react-icons/io";

export function Contacts({ message }) {

    const { contacts } = message;
    const qtdContacts = contacts?.length;
    const [openModal, setOpenModal] = useState(false);

    const description = () => {
        return (`
            ${contacts[0]?.contact_name}
            ${(qtdContacts > 1)
                ? ` e ${qtdContacts - 1} 
                    ${(qtdContacts - 1 === 1)
                    ? 'outro contato'
                    : 'outros contatos'
                }`
                : ''
            }
        `);
    };
    
    return (
        <>
            <Container
                isUserSystem={message?.user_system ? true : false}
                onClick={() => {
                    setOpenModal(true);
                }}
            >
                <Content>
                    <div>
                        <IconContact>
                            <IoMdContact fontSize={60}/>
                        </IconContact>
                        <Description>
                            <div>
                                {description()}
                            </div>
                        </Description>
                    </div>
                </Content>
                <span>
                    {`Ver ${qtdContacts > 1 ? 'contatos' : 'contato'}`}
                </span>
                <Footer message={message} />
            </Container>
            <Modal
                title={`${qtdContacts} Contatos`}
                isOpen={openModal}
                close={() => setOpenModal(false)}
            >
                {openModal && <List contacts={contacts}/>}
            </Modal>
        </>
    )
}